module.exports = __webpack_public_path__ + "img/client-centro-oeste.d65f0fbf.jpg";